import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ManagementApiService } from '../../../../services';
import { SharedContentCategory } from '../../../settings/enums/shared-content-category.enum';
import { SharedContentModel } from '../../../settings/models/general/shared-content-model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-home-news-updates',
    templateUrl: './home-news-updates.component.html',
    styleUrls: ['./home-news-updates.component.scss'],
    standalone: false,
})
export class HomeNewsUpdatesComponent implements OnInit, OnDestroy {
    sharedContentsFullList: SharedContentModel[];
    sharedContentsList: SharedContentModel[] = null;
    isLoadMoreButton: boolean;
    userLanguageSub: Subscription;

    constructor(
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private user_utlity: UserUtilityService,
        private globalEmittersService: GlobalEmittersService
    ) {
        this.isLoadMoreButton = false;
    }

    ngOnInit(): void {
        this.userLanguageSub = this.globalEmittersService.isUserDefaultsLoaded.subscribe((res) => {
            if (res) {
                this.getSharedContents(this.translocoService.getActiveLang());
            }
        });
    }

    async getSharedContents(language: string) {
        this.sharedContentsList = [];
        let temp = await this.mgmtApi.getSharedContentForHomePage(SharedContentCategory.NewsUpdates, language).toPromise();
        if (temp.success === true) {
            this.sharedContentsFullList = temp.response.sort((a, b) => {
                return <any>new Date(b.date) - <any>new Date(a.date);
            });
            this.isLoadMoreButton = this.sharedContentsFullList.length > 9 ? true : false;
            if (this.sharedContentsFullList.length >= 9) {
                this.sharedContentsList = this.sharedContentsFullList.slice(0, 9);
            } else {
                this.sharedContentsList = this.sharedContentsFullList;
            }
            //Image with byte stream conversion
            // this.getImgByte()
            this.cd.markForCheck();
        } else {
            this.user_utlity.errorModelPopup(temp.message);
        }
    }

    loadMore() {
        let lastindex = this.sharedContentsList.length - 1;
        if (this.sharedContentsFullList.length >= lastindex && this.sharedContentsFullList.length >= lastindex + 4) {
            this.sharedContentsList = this.sharedContentsFullList.slice(0, lastindex + 4);
            //Image with byte stream conversion
            //  this.getImgByte()
        } else if (this.sharedContentsFullList.length > lastindex) {
            this.isLoadMoreButton = false;
            this.sharedContentsList = this.sharedContentsFullList.slice(0, this.sharedContentsFullList.length);
            //Image with byte stream conversion
            // this.getImgByte()
        }
    }

    //Image with byte stream conversion

    //  async getImgByte(){
    //   this.sharedContentsListDisplay=[];
    //     this.sharedContentsList.map(x=>{
    //       let obj:any={}
    //       obj.navigationLink=x.navigationLink;
    //       obj.sharedContentType=x.sharedContentType;
    //       obj.heading=x.heading;
    //       obj.subHeading=x.subHeading;
    //       obj.date=x.date;
    //       obj.navigationText=x.navigationText;
    //      if(x.image){
    //       this.documentApiService.getImgBytes([x?.image]).toPromise().then((resp)=>{
    //         obj.image=resp.response.content;
    //       });
    //      }
    //      this.sharedContentsListDisplay.push(obj)
    //     });

    //   }
    ngOnDestroy() {
        if (this.userLanguageSub) {
            this.userLanguageSub.unsubscribe();
        }
    }
}
